import { createMuiTheme } from "@material-ui/core";

/**
 * A centralized place to manage all important global UI style decisions, usually related to branding.
 * These need to be consistent between all related applications, including those that use other frameworks.
 *
 * The intention is to strive for a portable configuration that is to be **re-used by all other projects**,
 * so feel free to refactor any of the fields in any old projects to keep up with the latest changes
 * whenever other project changes their own copy based on new requirements.
 */
export const appStyle = {
    fonts: [
        'Verdana',
        'sans-serif',
    ],
    header: {
        backgroundColor: '#004C66',
        fontWeight: 900,
    },
    table: {
        headerStyle: {
            fontSize: '.875rem',
            backgroundColor: '#E5EDEF',
            color: '#000',
        } as React.CSSProperties,
        cell: {
            fontSize: '.75rem',
            nameStyle: {
                minWidth: '200px',
            } as React.CSSProperties,
            descriptionStyle: {
                minWidth: '260px',
            } as React.CSSProperties,
        },
        row: {
            hoverColor: '#E5EDEF',
        },
    },
    footerStyle: {
        boxSizing: 'border-box',
        height: '34px',
        padding: '8px',
        background: '#004C66',
        color: '#FFF',
        // zIndex and relative position to display above a Backdrop
        zIndex: 1,
        position: 'relative',
    } as React.CSSProperties,
    ripple: {
        backgroundColor: 'gray',
    },
    menu: {
        linkColor: 'rgba(0,0,0,.87)',
    },
    window: {
        // We set this large enough to avoid forcing the user to scroll inside a tiny table
        minHeightToUseStickyHeaderAndFooter: 500,
    },
}

export const muiTheme = createMuiTheme({
    palette: {
        primary: {
            main: appStyle.header.backgroundColor,
        },
    },
    typography: {
        fontFamily: appStyle.fonts.join(','),
        h6: {
            fontWeight: appStyle.header.fontWeight,
        },
    },
    overrides: {
        MuiTableCell: {
            body: {
                fontSize: appStyle.table.cell.fontSize,
                wordBreak: 'break-word',
            },
        },
        MuiTableRow: {
            hover: {
                "&:hover": {
                    backgroundColor: `${appStyle.table.row.hoverColor} !important`,
                },
                // The onRowClick prop (required to enable hover style) causes the cursor to be a 'pointer' (hand)
                // by default, so we override <td> style using class (w/ lower priority) to change it back to arrow
                cursor: 'unset !important',
            },
        },
        MuiTouchRipple: {
            child: appStyle.ripple,
        },
        MuiListItemText: {
            root: {
                color: appStyle.menu.linkColor,
            },
        },
    },
});
